"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleListForDriverId = exports.vehicleCreate = void 0;
const Vehicle_1 = require("../models/Vehicle");
const cleanForFirestore_1 = __importDefault(require("../util/cleanForFirestore"));
const PATH = 'vehicles';
async function vehicleCreate(data, firestore) {
    await firestore.create(PATH, (0, cleanForFirestore_1.default)(data));
}
exports.vehicleCreate = vehicleCreate;
async function vehicleListForDriverId(driverId, firestore) {
    const results = await firestore.list(PATH, { where: [['driverId', '==', driverId]] });
    return results.map(result => (0, Vehicle_1.vehicleDeserialize)(result.value, result.id));
}
exports.vehicleListForDriverId = vehicleListForDriverId;
